module.exports = __webpack_public_path__ + "img/guinea-bissau.e1d3421a.svg";